import React, { useState, useEffect } from "react";
import styles from "./LandingScreen.module.scss";
import classNames from "classnames/bind";
import { NavLink } from "react-router-dom";

const LandingScreen = (props) => {
  const c = classNames.bind(styles);
  // const history = useHistory();
  const { landing } = props;
  const [currentLanguage, setCurrentLanguage] = useState("en");
  const [titleActive, setTitleActive] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setTitleActive(true);
    }, 1000);

    
  }, []);

  return (
    <div
      className={c({ main: true }, { hidden: !landing })}
      onClick={() => {
        setTitleActive(true);
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className={c({ logo: true })}
        viewBox="0 0 556.001 556"
      >
        <path
          id="Path_4"
          data-name="Path 4"
          d="M357.372,53.048c-153.29,0-278,124.711-278,278s124.71,278,278,278,278-124.709,278-278S510.661,53.048,357.372,53.048Zm174.047,387.68c-10.933,18.747-33.107,27.524-51.512,20.337-18.145-7.085-29.427-28.085-25.723-47.879,3.769-20.14,20.59-33.233,42.506-32.985,3.06.035,6.115.5,9.911.831,10.848-24.945,4.016-46.535-9.828-70.188,19.125,7.406,29.3,19.882,36.725,34.172C550.131,377.031,549.805,409.2,531.419,440.728Zm-28.887,28.8c-15.853,13.009-31.722,15.736-47.816,15.172-36.055-1.263-63.906-17.368-82.315-48.881-10.947-18.739-7.684-42.363,7.625-54.854,15.091-12.314,38.926-11.81,54.339,1.15,15.683,13.186,18.811,34.271,7.817,53.232-1.535,2.648-3.443,5.078-5.6,8.222C452.97,465.285,475.128,469.954,502.533,469.532Zm-2.761-135.859c3.067,19.235-9.34,39.591-28.288,46.409-19.28,6.938-39.083-.948-49.957-19.978-1.517-2.657-2.662-5.528-4.3-8.971-27,3.262-42.172,20.077-55.571,43.986-3.287-20.243,2.326-35.334,10.9-48.967,19.2-30.543,47.117-46.536,83.613-46.626C477.871,299.473,496.66,314.16,499.772,333.673Zm-324.02,98.806c-10.947-18.739-7.684-42.363,7.625-54.854,15.092-12.314,38.926-11.81,54.339,1.15,15.683,13.186,18.811,34.271,7.817,53.232-1.535,2.647-3.443,5.078-5.6,8.221,16.385,21.713,38.543,26.382,65.947,25.96-15.853,13.01-31.721,15.737-47.815,15.172C222.011,480.1,194.161,463.992,175.752,432.479ZM406.74,298.525c-15.853,13.01-31.722,15.737-47.815,15.173-36.055-1.264-63.906-17.368-82.316-48.881-10.946-18.739-7.684-42.363,7.626-54.854,15.091-12.314,38.925-11.81,54.339,1.15,15.683,13.186,18.811,34.271,7.816,53.232-1.534,2.647-3.443,5.078-5.6,8.221C357.178,294.279,379.336,298.948,406.74,298.525Zm-103.619,31.8c3.068,19.236-9.34,39.591-28.288,46.41-19.28,6.938-39.083-.948-49.956-19.979-1.518-2.657-2.662-5.527-4.3-8.97-27.005,3.262-42.172,20.077-55.572,43.986-3.287-20.243,2.327-35.334,10.9-48.967,19.2-30.542,47.117-46.536,83.613-46.625C281.221,296.129,300.01,310.817,303.122,330.329ZM283.257,457.722c-18.144-7.085-29.427-28.085-25.722-47.879,3.768-20.14,20.589-33.233,42.506-32.986,3.059.035,6.115.5,9.911.832,10.848-24.945,4.015-46.535-9.829-70.188,19.125,7.406,29.3,19.882,36.726,34.172,16.632,32.015,16.306,64.185-2.079,95.712C323.836,456.132,301.662,464.909,283.257,457.722Zm49.288-137.711a102.292,102.292,0,0,0,47.21.565,102.2,102.2,0,0,0-24.439,41.333A102.08,102.08,0,0,0,332.544,320.011Zm51.57-29.951c-18.144-7.085-29.426-28.085-25.722-47.879,3.769-20.14,20.589-33.233,42.506-32.985,3.06.035,6.115.5,9.911.831,10.848-24.945,4.016-46.535-9.828-70.188,19.124,7.406,29.3,19.882,36.726,34.172,16.632,32.015,16.306,64.185-2.079,95.712C424.694,288.47,402.52,297.247,384.114,290.06Zm19.865-127.393c3.068,19.235-9.339,39.591-28.288,46.409-19.279,6.938-39.082-.948-49.956-19.979-1.518-2.657-2.662-5.527-4.3-8.97-27.005,3.262-42.172,20.077-55.571,43.986-3.287-20.243,2.326-35.334,10.9-48.967,19.2-30.542,47.117-46.536,83.613-46.625C382.079,128.467,400.867,143.155,403.979,162.667ZM120.351,435.415A257.5,257.5,0,0,1,98.367,331.049c0-129.531,95.579-237.154,219.912-256.057,12.378-1.616,22.661,3.449,25.839,11.4,5.384,13.461,6.754,32.3,6.754,32.3l.145,0a102.268,102.268,0,0,0-69.674,170.5,102.289,102.289,0,0,0-115.6,146.385c-6.542,2.846-19.665,8.051-29.854,8.875C130.508,444.886,124.7,444.48,120.351,435.415ZM556.7,496.254a258.578,258.578,0,0,1-199.323,93.8c-82.37,0-155.878-38.654-203.35-98.77-3.129-4.209-6.882-13.183-.8-21.662,6.142-8.557,16.2-16.478,21.123-20.263A102.3,102.3,0,0,0,354.366,418.3a102.308,102.308,0,0,0,186.324,26.449c5.707,4.452,16.3,13.314,21.82,21.72C567.649,474.3,565.176,485.429,556.7,496.254Zm19.588-57.072c-10.672-1.566-22.8-6.549-28.309-9A102.273,102.273,0,0,0,430.783,291.969a102.248,102.248,0,0,0-64.525-173.083c.269-2.628,2.454-22.46,8.371-34.294,3.218-6.436,10.321-11.068,22.258-9.539,124.129,19.082,219.491,126.611,219.491,256a257.775,257.775,0,0,1-16.016,89.682C595.987,433.081,585.4,440.52,576.283,439.182Z"
          transform="translate(-79.372 -53.048)"
          fill="#fff"
        />
      </svg>

      <div className={c({ title: true }, { active: titleActive }, { japanese: currentLanguage === "日本" })}>
        <p>
          {currentLanguage === "en" ? "Talks at Shogyoji" : "正行寺講話"}
        </p>
        <p>{currentLanguage === "en" ? "by John White" : "ジョン・ホワイト"}</p>
      </div>
      <div
        className={c(
          { sidebar: true },
          { active: titleActive },
          { japanese: currentLanguage === "日本" }
        )}
      >
        <NavLink
          to={currentLanguage === "en" ? "/en/about" : "/日本/約"}
          className={c(
            { startButton: true },
            { japanese: currentLanguage === "日本" }
          )}
        >
          <p>{currentLanguage === "en" ? "Enter" : "入 る"}</p>
        </NavLink>
        <div
          className={c(
            { button: true },
            { active: currentLanguage === "日本" },
            { japanese: true }
          )}
          onClick={() => {
            setCurrentLanguage("日本");
          }}
        >
          <p>日 本 語</p>
        </div>
        <div
          className={c({ button: true }, { active: currentLanguage === "en" })}
          onClick={() => {
            setCurrentLanguage("en");
          }}
        >
          <p>EN</p>
        </div>
      </div>
    </div>
  );
};

export default LandingScreen;
